import React, { useEffect } from "react";
import { Result, Button } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

const SuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { orderNumber = null } = location.state || {};

  useEffect(() => {
    const closeTimer = setTimeout(() => {
      if (window.history.length > 1) {
        navigate("/", { replace: true });
      } else {
        window.close();
      }
    }, 10000);

    return () => {
      clearTimeout(closeTimer);
    };
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 30,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Result
          status="success"
          title="Thank you for your Order"
          subTitle={
            <div style={{ fontSize: 16 }}>
              <p>Successfully Placed Order</p>
              {orderNumber && <p>Order Number: {orderNumber}</p>}
            </div>
          }
        />
        <Button
          onClick={() => navigate("/")}
          style={{
            backgroundColor: "#00BF63",
            color: "#fff",
            borderColor: "#00BF63",
            width: "120px",
            fontSize: "20px",
            fontWeight: "semibold",
            padding: "20px",
          }}
          size="large"
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default SuccessPage;
